import React from 'react';

export default function ProblemsViewComponen2({  }) {
    return (
        <section className="py-16 px-4 bg-gray-100">
            <div className="max-w-6xl mx-auto">
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
                        Why Top Families Choose Extern Academy
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Externs work in teams of 10, running their startup like professionals to launch a product by Deployment Day.
                    </p>
                </div>

                {/* Trust badges row */}
                <div className="flex flex-wrap justify-center gap-6 mb-16">
                    <div className="bg-gray-50 rounded-xl px-6 py-4 text-center min-w-[160px] shadow-sm border border-gray-100">
                        <div className="font-bold text-gray-800">~8–12 hrs/week</div>
                        <div className="text-sm text-gray-500">Fits around school & activities</div>
                    </div>
                    <div className="bg-gray-50 rounded-xl px-6 py-4 text-center min-w-[160px] shadow-sm border border-gray-100">
                        <div className="font-bold text-gray-800">Live product</div>
                        <div className="text-sm text-gray-500">Shipped, usable, portfolio‑ready</div>
                    </div>
                    <a
                        href="/education/trainer"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-gray-50 rounded-xl px-6 py-4 text-center shadow-sm border border-gray-100 transition-all duration-200 hover:shadow-md hover:border-blue-200 text-decoration-none"
                    >
                        <div className="flex items-center justify-center gap-1.5">
                            <span className="font-bold text-gray-800">Founder‑led</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 text-blue-500">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                            </svg>
                        </div>
                        <div className="text-sm text-gray-500">Raised $1M+ & scaled 100k+ users</div>
                    </a>
                </div>

                {/* Feature cards grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <FeatureCard
                        title="College admissions edge"
                        description="Admissions officers see thousands of similar GPAs. Your child’s shipped product and founder‑mentored story becomes the unforgettable differentiator."
                    />
                    <FeatureCard
                        title="Proof over potential"
                        description="A live consumer product they can point to, demo, and include in resumes, portfolios, and interviews. It’s the evidence of initiative top schools and employers crave."
                    />
                    <FeatureCard
                        title="Startup network, early"
                        description="Your child builds alongside a vetted founder and a cohort of ambitious peers, forming relationships that last through college and into their first venture."
                    />
                </div>
            </div>
        </section>
    );
};

const FeatureCard = ({ title, description }) => (
    <div className="bg-white rounded-xl p-6 border-t-white border-t-2 transition hover:shadow-md hover:border-blue-400">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
    </div>
);
